/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import CostWeightedIcon from "@/src/assets/icons/serviceOverview/IconCosts";
import ServiceWeightedIcon from "@/src/assets/icons/serviceOverview/IconServicewelt";
import AssistanceWeightedIcon from "@/src/assets/icons/serviceOverview/IconAssistantSmile";
import serviceSectionStyle from "./serviceSectionStyle";
import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import TextContainer from "@/src/components/Container/TextContainer";
import Typography from "@mui/material/Typography";
import GradientPaper from "@/src/components/GradientComponents/GradientPaper";
import { Box } from "@mui/material";

type ServiceSectionProps = {
  product?: "divorce" | "generic" | "settlement";
};

export const ServiceSection = ({ product = "divorce" }: ServiceSectionProps) => {
  return (
    <>
      <Container sx={serviceSectionStyle.centered}>
        <Box id="service">
          {" "}
        </Box>
        <Typography component={"h2"} variant={"h3"}>Unser Service: Das Rundum-Sorglos-Paket</Typography>
        <Typography component={"h3"} variant={"h4"}>Einfach, schnell und professionell beraten!</Typography>
      </Container>
      <Box>
        <TextContainer sx={serviceSectionStyle.centered}>
          <Grid container>
            <Grid size={12}>
              <GradientPaper sx={serviceSectionStyle.paper}>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <CostWeightedIcon sx={serviceSectionStyle.icon} />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h4"} variant={"h5"}>Transparente Kostenübersicht</Typography>
                    <Typography variant={"body2"}>Keine versteckten Kosten und nur Mindestgebühren: Wir ermöglichen Ihnen immer den günstigsten Preis!</Typography>
                  </Grid>
                </Grid>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h4"} variant={"h5"}>Individueller Servicebereich</Typography>
                    <Typography variant={"body2"}>
                      {product !== "divorce" && <>Umfassende Informationen, Ihre Angaben und wichtige Dokumente </>}
                      {product === "divorce" && (
                        <>Ihr persönlicher Scheidungsplaner inklusive Tipps und Checklisten, umfassende Informationen und wichtige Dokumente </>
                      )}
                      - Alles sicher an einem Ort und immer griffbereit.
                    </Typography>
                  </Grid>
                  <Grid
                    sx={serviceSectionStyle.gridItemReversed}
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <ServiceWeightedIcon sx={serviceSectionStyle.icon} />
                  </Grid>
                </Grid>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <AssistanceWeightedIcon sx={serviceSectionStyle.icon} />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h4"} variant={"h5"}>Persönlicher Ansprechpartner</Typography>
                    <Typography variant={"body2"}>Ihr persönlicher Ansprechpartner in der Mandantenbetreuung und unsere Anwälte begleiten Sie und helfen jederzeit weiter.</Typography>
                  </Grid>
                </Grid>
              </GradientPaper>
            </Grid>
          </Grid>
        </TextContainer>
      </Box>
    </>
  );
};

export default ServiceSection;
